// extracted by mini-css-extract-plugin
export default {"overlay":"OrderModal_overlay__il9FI","modal":"OrderModal_modal__zYtrg","detailList":"OrderModal_detailList__wiDh5","footer":"OrderModal_footer__-ovp5"};